var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty",style:(_vm.sizeBox)},[_c('JwChat-icon',{style:(_vm.sizeStyle),attrs:{"type":"icon-empty"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }